module.exports = __webpack_public_path__ + "static/media/incident_category-regulatory.6a8be2a2.svg";